import { MDBContainer, MDBFooter } from "mdb-react-ui-kit";

const FooterPage = () => {
  return (
    <MDBFooter className="font-small fixed-bottom lighten-5 ">
      <div
        className="footer-copyright text-center py-3"
        style={{ backgroundColor: "rgb(236 239 241)" }}
      >
        <MDBContainer fluid>
          <div className="black-text">
            &copy; {new Date().getFullYear()} Copyright:toyota.com
          </div>
        </MDBContainer>
      </div>
    </MDBFooter>
  );
};

export default FooterPage;
